/* eslint-disable */

window.googletag = window.googletag || {cmd: []};

googletag.cmd.push(function() {

	const isArticle = document.querySelector('.advert-gpt--type-article');
	const isNewsletter = document.querySelector('.advert-gpt--type-newsletter');

	if (isArticle) {
		googletag.display('div-gpt-ad-1774350517522-0');
	} else if (isNewsletter) {
		googletag.display('div-gpt-ad-1763037525175-0');
	}
});
